export function formatDate(creation_date) {
  return creation_date.toLocaleDateString('en-us', { year:"numeric", month:"short"})
}
